import type { TeamCard } from '../../../shared/dashboard-data';
import { formatArea, formatLengthKm } from '../../utils/formatters';

interface TeamPanelProps {
  teams: TeamCard[];
}

function TeamStatusTag({ status }: { status: TeamCard['status'] }) {
  return <span className={`team-status status-${status}`}>{status}</span>;
}

export function TeamPanel({ teams }: TeamPanelProps) {
  return (
    <section className="panel matte-frame">
      <h2 className="panel-title">养护单位</h2>
      <ul className="team-list">
        {teams.map((card) => (
          <li key={`${card.maintenanceUnit}-${card.teamInfo}-${card.leader}`} className="team-row">
            <div>
              <div className="team-unit">{card.maintenanceUnit}</div>
              <div className="team-meta">
                {card.teamInfo} / 负责人：{card.leader}
              </div>
              <div className="team-metric">
                面积 {formatArea(card.areaM2)}㎡ · 作业长度 {formatLengthKm(card.shapeLengthKm)}km · 道路长度{' '}
                {formatLengthKm(card.roadLengthKm)}km
              </div>
            </div>
            <TeamStatusTag status={card.status} />
          </li>
        ))}
      </ul>
    </section>
  );
}
